import { ref } from "vue";

/**
 * 
 * @param {any} callback
 * @param {ActionOptions} options 
 * @returns
 */
export default function useAction(callback, options = {}) {
    const loading = ref(false);
    const error = ref(null);
    const data = ref(null);
    const invoke = async(...args) => {
        loading.value = true;
        error.value = null;
        try {
            const response = await callback(...args);
            if (options.onSuccess) {
                options.onSuccess(response);
            }
            return response;
        } catch (err) {
            console.log("Error:", err);
            error.value = err;
            if (options.onError) {
                options.onError(err);
            }
        } finally {
            loading.value = false;
        }
    }

    return {
        loading,
        error,
        data,
        invoke
    }
}